import { useMemo } from "react";
import { getColorFromCssVariable } from "ui";
import { LineChartCard } from "./shared/LineChartCard";
import { useDatadogQuery } from "../DatadogAnalytics/useDatadogQuery";

type RevenueData = {
  value: number;
  label: string;
}[];

export function RevenueChart() {
  const { ref, queryStatus, data, error, refetch } =
    useDatadogQuery<RevenueData>({
      chartType: "CAPTURE_REVENUE",
    });

  const { labels, revenueData } = useMemo(() => {
    if (!Array.isArray(data) || data.length === 0)
      return { labels: [], revenueData: [] };

    return {
      labels: data.map((item) => item.label),
      revenueData: data.map((item) => item.value),
    };
  }, [data]);

  const color = useMemo(() => getColorFromCssVariable("--chart-brand"), []);

  return (
    <LineChartCard
      ref={ref}
      title="Revenue"
      description="Total value of successfully captured payments in the selected period in USD."
      format="currency"
      labels={labels}
      queryStatus={queryStatus}
      error={error}
      retry={refetch}
      datasets={[
        {
          label: "Revenue",
          data: revenueData,
          backgroundColor: color,
          borderColor: color,
        },
      ]}
    />
  );
}
